import React from "react";
import { Box, Typography, Link, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();
  return (
    <Box sx={{ bgcolor: "#f7f7f7", py: 3, mt: 6, borderTop: "1px solid #e0e0e0" }}>
      <Container maxWidth="md" sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box sx={{ mb: 1, display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
          <Link component="button" onClick={() => navigate("/about")} underline="hover" sx={{ mx: 1, color: "#1976d2" }}>About Us</Link>
          <Typography sx={{ mx: 1 }}>|</Typography>
          <Link component="button" onClick={() => navigate("/terms")} underline="hover" sx={{ mx: 1, color: "#1976d2" }}>Terms</Link>
          <Typography sx={{ mx: 1 }}>|</Typography>
          <Link component="button" onClick={() => navigate("/contact")} underline="hover" sx={{ mx: 1, color: "#1976d2" }}>Contact</Link>
          <Typography sx={{ mx: 1 }}>|</Typography>
          <Link component="button" onClick={() => navigate("/faq")} underline="hover" sx={{ mx: 1, color: "#1976d2" }}>FAQ</Link>
          <Typography sx={{ mx: 1 }}>|</Typography>
          <Link component="button" onClick={() => navigate("/tips")} underline="hover" sx={{ mx: 1, color: "#1976d2" }}>Tips & Safety</Link>
        </Box>
        <Typography variant="body2" color="text.secondary" align="center">
          © {new Date().getFullYear()} Lost & Found Portal. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
}
export default Footer;